import React, {Component} from "react";

// import Amplify from 'aws-amplify';
// import awsExports from '../../aws-exports';
// import {AmplifySignOut, withAuthenticator} from '@aws-amplify/ui-react'
// import { Authenticator, SignIn, SignUp, ConfirmSignUp, Greetings } from 'aws-amplify-react';
// import {CustomSignIn} from '../CustomSignIn'
// import config from '../../aws-exports'

import Layer1 from "../../layers/Layer1"
import Layer2 from "../../layers/Layer2"
import Layer3 from "../../layers/Layer3"
import Layer4 from "../../layers/Layer4"


import "../index.scss";

//Amplify.configure(awsExports)

const Main = () => {

    return  (
        <div className="ui-main">
            <Layer1 />
            <Layer2 context="Main" />
            <Layer3 />
            <Layer4 />
        </div>
    )

}

export default Main;